var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"action-prop-table"},[_c('tr',[_c('th',[_vm._v("quest")]),_c('td',[_vm._v(_vm._s(_vm._f("getProtoAlias")(_vm.questProtoId)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }